export default __webpack_public_path__ + "static/media/judge.7da82b4b.svg";